import { createStore } from 'vuex'
import orderModule from "./modules/order"

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    order: orderModule
  }
})
